module.exports = __webpack_public_path__ + "static/media/sidebar-2.9f670e98.jpg";